"use client";
import { useRouter, usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";

type Props = {
  children: React.ReactNode;
};

const LAST_PATH_KEY = "lastPath";
function MainLayout({ children }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => {
    // Save current path if it's not the offline page
    if (pathname !== "/offline") {
      sessionStorage.setItem(LAST_PATH_KEY, pathname);
    }
  }, [pathname]);

  useEffect(() => {
    document.title = "صفحه ورود";
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    const handleOffline = () => {
      router.push("/offline");
    };

    const handleOnline = () => {
      const lastPath = sessionStorage.getItem(LAST_PATH_KEY) || "/";
      if (window.location.pathname === "/offline") {
        router.replace(lastPath); // replace تا تاریخچه مرورگر خراب نشه
      }
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [router]);

  if (!isHydrated) return;
  return <div>{children}</div>;
}

export default MainLayout;
